<template>
  <div id="VehicleManagement">
    <v-container fluid>
      <v-card height="70" class="elevation-0">
        <v-card-title>
          <v-row>
            <v-col class="pa-0 pl-4" cols="auto">
              <span class="text-h6">Vehicles ({{ vehicles.length }})</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="pa-0" cols="2">
              <v-text-field clearable dense label="Search" outlined v-model="search"></v-text-field>
            </v-col>
            <v-col class="pa-0 ml-5 mr-1" cols="auto">
              <v-btn @click="startCreateTempo" class="primary elevation-0">
                CREATE VEHICLE
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <v-row>
        <v-col cols="12" class="px-5">
          <v-data-table fixed-header height="calc(100vh - 320px)" :footer-props="{itemsPerPageOptions:[25,50,100]}" :items-per-page="25" :headers="headers"
                        :items="vehicles" :search="search" class="elevation-0">
            <template v-slot:no-data>No Vehicles Available</template>
            <template v-slot:no-results>No Vehicles Available</template>
            <template v-slot:item.platNo="{ item }">
              {{ item.platNo ? item.platNo : '-' }}
            </template>
            <template v-slot:item.name="{ item }">
              {{ item.name ? item.name : '-' }}
            </template>
            <template v-slot:item.pucExpiryDate="{ item }">
              {{ dateFormat(item.pucExpiryDate) }}
            </template>
            <template v-slot:item.insuranceDate="{ item }">
              {{ dateFormat(item.insuranceDate) }}
            </template>
            <template v-slot:item.fitnessCertificate="{ item }">
              {{ dateFormat(item.fitnessCertificate) }}
            </template>
            <template v-slot:item.oilChangeOn="{ item }">
              {{ dateFormat(item.oilChangeOn) }}
            </template>
            <template v-slot:item.installmentEmiOn="{ item }">
              {{ dateFormat(item.installmentEmiOn) }}
            </template>
            <template v-slot:item.lastServiceOn="{ item }">
              {{ dateFormat(item.lastServiceOn) }}
            </template>
            <template v-slot:item.isActive="{ item }">
              {{ item.isActive ? 'Yes' : 'No' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu nudge-bottom="25">
                <template v-slot:activator="{ on:menu }">
                  <v-btn icon v-on="{...menu}">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item :key="i" @click="onClickAction(action,item)" dense
                               v-for="(action, i) in actionArr">
                    <v-list-item-title> {{ action.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <CreateUpdateVehicle :vehicle="selectedVehicle" :vehicleDialog="vehicleDialog" @cancel="vehicleDialog=false"
                         @saveTempo="saveTempo" v-if="vehicleDialog"></CreateUpdateVehicle>
    <ConfirmationDialog :confirmationMessage="confirmMsg" @close="confirmationDialog=false;confirmMsg = 'Confirm! '"
                        @confirm="confirmAction" v-if="confirmationDialog"></ConfirmationDialog>
    <Snackbar :toaster="toaster"></Snackbar>
  </div>
</template>

<script>
import ConfirmationDialog from '../Common/ConfirmationDialog'
import Snackbar from '../Common/Snackbar'
import moment from 'moment'
import { SUBSCRIBE_ALL_VEHICLES } from '@/graphql/subscriptions/Vehicles'
import CreateUpdateVehicle from './CreateUpdateVehicle'

export default {
  name: 'VehicleManagement',
  components: { CreateUpdateVehicle, Snackbar, ConfirmationDialog },
  data () {
    return {
      moment: moment,
      search: '',
      confirmationDialog: false,
      vehicleDialog: false,
      toaster: { enable: false, color: 'green', message: '' },
      confirmMsg: 'Confirm! ',
      selectedAction: {},
      selectedVehicle: {},
      headers: [
        { text: 'Vehicle Number', value: 'platNo' },
        { text: 'Vehicle Name', value: 'name' },
        { text: 'PUC End Date', value: 'pucExpiryDate' },
        { text: 'Insurance Date', value: 'insuranceDate' },
        { text: 'Fitness Certificate', value: 'fitnessCertificate' },
        { text: 'Oil Change On', value: 'oilChangeOn' },
        { text: 'Installment/EMI On', value: 'installmentEmiOn' },
        { text: 'Last Service On', value: 'lastServiceOn' },
        { text: 'Actions', value: 'actions' },
      ],
      vehicles: [],
      actionArr: [
        { id: '1', title: 'Edit' }, { id: '2', title: 'Delete' },
      ],
      loggedInUser: JSON.parse(localStorage.user),
    }
  },
  apollo: {
    $subscribe: {
      Vehicles: {
        query: SUBSCRIBE_ALL_VEHICLES, fetchPolicy: 'network-only',
        skip () { return !this.loggedInUser },
        variables () { return { orgId: this.loggedInUser.organizationId } },
        result ({ data, loading }) { if (!loading) { this.vehicles = data.Vehicles } },
      },
    },
  },
  methods: {
    onClickAction (selectedAction, selectedVehicle) {
      this.selectedVehicle = selectedVehicle
      this.selectedAction = this.actionArr.filter(action => selectedAction.id === action.id)[0]
      if (this.selectedAction.id === '1')
        this.confirmAction()
      else if (this.selectedAction.id === '2')
        this.confirmMsg = this.confirmMsg.concat('this will delete vehicle, are you sure?')
      this.confirmationDialog = this.selectedAction.id !== '1'
    },
    confirmAction () {
      this.confirmationDialog = false
      this.confirmMsg = 'Confirm! '
      if (this.selectedAction.id === '1')
        this.updateVehicle()
      else if (this.selectedAction.id === '2')
        this.deleteVehicle()
    },
    startCreateTempo () {
      this.selectedVehicle = null
      this.vehicleDialog = true
    },
    updateVehicle () {
      this.vehicleDialog = true
    },
    deleteVehicle () {
      this.toaster = { enable: true, color: 'green', message: 'Vehicle successfully deleted' }
    },
    saveTempo () {
      this.toaster = {
        enable: true, color: 'green',
        message: `Vehicle ${this.selectedVehicle ? 'updated' : 'created'} successfully`,
      }
      this.vehicleDialog = false
    },
    dateFormat (date) {
      return date ? moment(date).format('DD/MM/YYYY') : '-'
    },
  },
}
</script>
<style scoped>
.v-list {
  padding: 0;
}
</style>
